import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { lookupAddress } from '../../api/lookup';
import { useGuide } from '../../hooks/useGuide';

export default function GuideLanding() {
  const navigate = useNavigate();
  const { setLookupResultAndAddress } = useGuide();
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!address.trim()) return;

    setLoading(true);
    setError('');

    try {
      const result = await lookupAddress(address.trim());

      if (!result.ok) {
        setError('Something went wrong. Please try again.');
        return;
      }

      if (result.outOfScope) {
        setError(
          `We currently only support ${result.county ?? 'your'} County. Check back soon for more counties.`
        );
        return;
      }

      if (result.noUpcomingElection) {
        setError(
          "We don't have an upcoming election on file for your address yet. Check back closer to election day."
        );
        return;
      }

      if (result.error === 'AddressNotFound') {
        setError("We couldn't find that address. Try including your city and state.");
        return;
      }

      setLookupResultAndAddress(address.trim(), result);
      navigate('/guide/plan');
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <p className="g-label">First-Time Voter Guide</p>
      <h1 className="g-h1">
        Find your
        <br />
        <span style={{ color: 'var(--g-orange)' }}>ballot.</span>
      </h1>
      <p className="g-body">
        Enter your address and we'll show you your polling place, everything on your ballot in plain
        English, and how to make a plan.
      </p>

      {error && <div className="g-error">{error}</div>}

      <form onSubmit={handleSubmit} style={{ marginBottom: 16 }}>
        <input
          className="g-input"
          type="text"
          placeholder="123 Main St, Austin, TX 78701"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          autoComplete="street-address"
          style={{ marginBottom: 12 }}
        />
        <button className="g-btn-primary" type="submit" disabled={loading || !address.trim()}>
          {loading ? 'Looking up your ballot…' : 'Find my ballot →'}
        </button>
      </form>

      <p style={{ fontSize: 13, color: 'var(--g-muted)', textAlign: 'center', marginTop: 12 }}>
        Your address is only used to find your ballot. It's never sold.
      </p>

      <hr className="g-divider" />

      <p style={{ fontSize: 14, color: 'var(--g-muted)', textAlign: 'center' }}>
        Not sure if you're registered?{' '}
        <a
          href="https://www.votetexas.gov/register-to-vote/index.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--g-orange)' }}
        >
          Check your registration →
        </a>
      </p>
    </div>
  );
}
